import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default {
  __name: 'LlSearch',
  props: {
    label: {
      type: String,
      default: ''
    },
    modelValue: {
      type: String,
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const updateValue = value => {
      emit('update:modelValue', value);
    };
    return (_ctx, _cache) => {
      const _component_v_text_field = _resolveComponent("v-text-field");
      return _openBlock(), _createBlock(_component_v_text_field, {
        modelValue: __props.modelValue,
        "onUpdate:modelValue": updateValue,
        label: __props.label,
        density: "compact",
        "prepend-inner-icon": "mdi-magnify",
        variant: "outlined",
        class: "remove-outline",
        "data-cy": "search",
        "hide-details": "",
        "single-line": ""
      }, null, 8, ["modelValue", "label"]);
    };
  }
};